import React from 'react';
function ConfigTracker() {
  return (
    <div className="placeholder-page">
      <div className="placeholder-icon">🎛️</div>
      <div className="placeholder-title">Config Tracker</div>
      <div className="placeholder-sub">Per-project register of Aumentum configuration items and their status. Coming soon.</div>
    </div>
  );
}
export default ConfigTracker;
